<footer class="caen-footer">
  <div class="row p-2 other-logos">
    <div class="col-md-12 text-center">
      <a href="https://alicia.concytec.gob.pe/" target="_blank">
        <img class="alicia-logo" src="assets/caen/images/alicia-logo.png" alt="ALICIA Logo" />
      </a>
      <a href="https://www.lareferencia.info/es/" target="_blank">
        <img class="referencia-logo" src="assets/caen/images/lareferencia-logo.png" alt="REFERENCIA Logo" />
      </a>
    </div>
  </div>
  <div class="footer-content">
    <div class="container mt-3">
      <div class="row">
         <!-- Logo Section -->
        <div class="footer-logo">
          <img src="assets/caen/images/caen-logo.svg" alt="CAEN Logo" />
        </div>
        <!-- About Section -->
        <div class="col">
          <h5>Nosotros</h5>
          <ul>
            <li><a href="https://caen.edu.pe/historia">Historia</a></li>
            <li><a href="https://caen.edu.pe/normatividad">Normatividad</a></li>
            <li><a href="https://caen.edu.pe/portal-de-transparencia">Portal de Transparencia</a></li>
            <li><a target="_blank" href="https://caen.edu.pe/wp-content/uploads/2023/02/REGLAMENTO-DEL-REPOSITORIO-INSTITUCIONAL-CAEN-EPG.pdf">Reglamento del repositorio institucional</a></li>

          </ul>
        </div>

        <!-- Academic Programs -->
        <div class="col">
          <h5>Posgrados</h5>
          <ul>
            <li><a href="https://caen.edu.pe/doctorados">Doctorados</a></li>
            <li><a href="https://caen.edu.pe/maestrias">Maestrías</a></li>
            <li><a href="https://caen.edu.pe/diplomados-y-cursos-especiales">Diplomados y Cursos Especiales</a></li>
          </ul>
        </div>

        <!-- Resources -->
        <div class="col">
          <h5>Recursos</h5>
          <ul>
            <li><a href="https://biblioteca.caen.edu.pe">Biblioteca</a></li>
            <li><a href="https://caen.turnitin.com">Turnitin</a></li>
          </ul>
        </div>

        <!-- Contact Information -->
        <div class="col">
          <h5>Contacto</h5>
          <p>Av. Alejandro Iglesias S/N - Chorrillos</p>
          <p>Email: <a href="mailto:repositorio@caen.edu.pe">repositorio@caen.edu.pe</a></p>
        </div>
      </div>

    </div>
  </div>
  <div class="footer-bottom">
    <p>&copy; 2023 Centro de Altos Estudios Nacionales</p>
    <p>Powered by <a href="https://caen.edu.pe">Camayoc.com</a></p>
  </div>
</footer>
